import { render, staticRenderFns } from "./OxyIndicatorLights.vue?vue&type=template&id=a508dee8&"
import script from "./OxyIndicatorLights.vue?vue&type=script&lang=ts&"
export * from "./OxyIndicatorLights.vue?vue&type=script&lang=ts&"
import style0 from "./OxyIndicatorLights.vue?vue&type=style&index=0&id=a508dee8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports